module.exports = __webpack_public_path__ + "static/media/prop-7.7ce829e5.webp";